var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          "left-side-class": "col-xl-4",
          page: _vm.pageInfo,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        },
        scopedSlots: _vm._u([
          {
            key: "customActions",
            fn: function() {
              return [
                _c("action-button", {
                  staticClass: "mr-3",
                  attrs: {
                    i: "fas fa-arrow-circle-left",
                    text: "Regresar",
                    variant: "outline-success"
                  },
                  on: {
                    click: function($event) {
                      return _vm.goBackHandler()
                    }
                  }
                }),
                !_vm.showSearchStudent && !_vm.isEducativeService
                  ? _c("action-button", {
                      staticClass: "mr-3",
                      attrs: {
                        i: "fas fa-search",
                        text: "Búsqueda de Estudiante",
                        variant: "outline-success"
                      },
                      on: {
                        click: function($event) {
                          _vm.showSearchStudent = true
                        }
                      }
                    })
                  : _vm._e(),
                !_vm.isPeriodFinalized &&
                !_vm.readonly &&
                !_vm.isEducativeService
                  ? _c("action-button", {
                      attrs: {
                        i: "fas fa-check-circle",
                        text: "Validar Visitas",
                        variant: "success"
                      },
                      on: { click: _vm.validateVisitHandler }
                    })
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("validation-observer", { ref: "searchStudentRef" }, [
        _vm.showSearchStudent
          ? _c(
              "div",
              { staticClass: "bg-gray-1 p-4 rounded mb-4 search-container" },
              [
                _c(
                  "div",
                  { staticClass: "search-container__search" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-input", {
                                  staticClass: "input w-25",
                                  attrs: {
                                    "custom-error-msg":
                                      "Favor escriba número de referido o SIE.",
                                    error: errors[0],
                                    icon: "fa fa-search orange-icon",
                                    "left-icon": "",
                                    placeholder:
                                      "Escriba Número de Referido o SIE"
                                  },
                                  model: {
                                    value: _vm.referralNumberOrSie,
                                    callback: function($$v) {
                                      _vm.referralNumberOrSie = $$v
                                    },
                                    expression: "referralNumberOrSie"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3798049164
                      )
                    }),
                    _c("action-button", {
                      staticClass:
                        "mr-n3 ml-0 ml-md-3 ml-sm-0 mt-3 mt-md-0 mt-sm-3",
                      attrs: {
                        i: "fas fa-search",
                        text: "Buscar",
                        variant: "success"
                      },
                      on: { click: _vm.searchStudent }
                    })
                  ],
                  1
                ),
                _c("action-button", {
                  staticClass: "mr-n2 px-3 mt-1 mt-md-0 mt-sm-1",
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cerrar",
                    variant: "outline-danger"
                  },
                  on: { click: _vm.onCloseSearchStudent }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      !_vm.studentInfo
        ? _c("custom-result-not-found", {
            attrs: { text: "No se ha encontrado información disponible" }
          })
        : _vm._e(),
      _vm.studentInfo && _vm.showContent
        ? _c(
            "div",
            [
              _c("additional-info", {
                attrs: {
                  "compensatory-info": _vm.compensatoryInfo,
                  "referral-count": _vm.referralCount,
                  "referral-current-page": _vm.referralCurrentPage,
                  referrals: _vm.referrals,
                  "student-info": _vm.studentInfo
                },
                on: { "on-change-page": _vm.onChangeNavigationPageHandler }
              }),
              !_vm.isEducativeService
                ? _c("student-intervention-plan-info", {
                    attrs: {
                      "has-plan": _vm.hasPlan,
                      "student-info": _vm.studentInfo
                    },
                    on: {
                      "on-view-document": function($event) {
                        return _vm.viewDocument($event)
                      },
                      "on-view-plan": _vm.onViewPlanHandler
                    },
                    model: {
                      value: _vm.interventionPlanList,
                      callback: function($$v) {
                        _vm.interventionPlanList = $$v
                      },
                      expression: "interventionPlanList"
                    }
                  })
                : _vm._e(),
              _vm.isEducativeService
                ? _c("student-pei-info", {
                    attrs: { value: _vm.studentPeiInfoData }
                  })
                : _vm._e(),
              _c("div", [
                _c("div", { staticClass: "separation-line" }),
                _c("div", { staticClass: "row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("period-selection", {
                        attrs: {
                          "completed-period": _vm.getIsPeriodFinalizedDate,
                          "current-period": _vm.getCurrentPeriod,
                          "disabled-periods": _vm.getDisabledDates,
                          "disabled-regular-period":
                            _vm.compensatoryInfo != null,
                          "initial-period": _vm.getInitialPeriod,
                          readonly: _vm.readonly
                        },
                        on: { input: _vm.onChangePeriod }
                      })
                    ],
                    1
                  )
                ]),
                !_vm.isEducativeService
                  ? _c("div", { staticClass: "row mt-5" }, [
                      _vm.referrals.length > 0
                        ? _c(
                            "div",
                            { staticClass: "col" },
                            [
                              _c("register-visit", {
                                key: _vm.registerVisitKey,
                                attrs: {
                                  "compensatory-info": _vm.compensatoryInfo,
                                  "is-period-finalized": _vm.isPeriodFinalized,
                                  "is-read-only": _vm.readonly,
                                  "referral-for-visits": _vm.referrals,
                                  "student-info": _vm.studentInfo
                                },
                                on: { "hook:mounted": _vm.runValidations }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm.isEducativeService
                ? _c("register-education-visit", {
                    staticClass: "mt-2",
                    attrs: {
                      "compensatory-info": _vm.compensatoryInfo,
                      "is-period-finalized": _vm.isPeriodFinalized,
                      "referral-for-visits": _vm.referrals,
                      "student-info": _vm.studentInfo
                    },
                    on: { reloadVisitTypes: _vm.loadVisitTypes }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }